// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization_integration".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { integrationTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "organization_integration" table (1:1 with a DB row, on the wire). */
export const organizationIntegrationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    type: z.enum(integrationTypeValues),
    isActive: z.boolean().nullable(),
    config: z.unknown().nullable(),
    encryptedCredentials: z.string().nullable(),
    lastSyncAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=organizationIntegration.js.map